<template>
  <router-and-print
    :data="params.data"
    :field="params.field"
    :use-route="params.useRoute"
    :use-print="params.usePrint"
    :route-name="params.routeName"
    :route-param-keys="params.routeParamKeys"
    :route-title="params.routeTitle"
    :route-permissions="params.routePermissions"
    :extra-route-params="params.extraRouteParams"
    :direct-mode="params.directMode"
    :direct-url="params.directUrl"
    :direct-params="params.directParams"
    :jump-instruction="params.jumpInstruction"
    :instruction-click="params.instructionClick"
    :print-method="()=>params.printMethod(params.data[field])"
  />
</template>
<script>
import Vue from 'vue'
import RouterAndPrint from '@/components/Cargo/Common/routerAndPrint'
export default Vue.extend({
  name: 'RouterAndPrintRenderer',
  components: { RouterAndPrint }
})
</script>
